import { render, staticRenderFns } from "./ExportLabelButton.vue?vue&type=template&id=4582f9e3&"
import script from "./ExportLabelButton.vue?vue&type=script&lang=js&"
export * from "./ExportLabelButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports